export default {
  OFormString: 'blur',
  OFormSingleselect: 'change',
  OFormMultiselect: 'change',
  OFormRadiogroup: 'change',
  OFormCheckboxgroup: 'change',
  OFormCheckbox: 'change',
  OFormSwitch: 'change',
  OFormTextarea: 'blur',
  OFormPassword: 'blur',
  OFormDate: 'blur',
  OFormFile: 'blur',
  OFormDiy: 'blur',
}
